export var NativeStreamUntrackedAction;
(function (NativeStreamUntrackedAction) {
    NativeStreamUntrackedAction["NATIVE_STREAM_UNTRACKED_ACTION_UNSPECIFIED"] = "NATIVE_STREAM_UNTRACKED_ACTION_UNSPECIFIED";
    NativeStreamUntrackedAction["NATIVE_STREAM_UNTRACKED_ACTION_KEEP"] = "KEEP";
    NativeStreamUntrackedAction["NATIVE_STREAM_UNTRACKED_ACTION_DROP"] = "DROP";
})(NativeStreamUntrackedAction || (NativeStreamUntrackedAction = {}));
